import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
}

/**
 * MapleKey placeholder mark.
 * A maple leaf composed inside a rounded shield, with a key bow lower right.
 * Replace with finalized brand asset when commissioned.
 */
export function Logo({ className }: LogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-primary", className)}
      aria-label="MapleKey"
    >
      <path
        d="M16 3.2 5.2 8.4v8.8c0 6.6 4.6 11.6 10.8 12.8 6.2-1.2 10.8-6.2 10.8-12.8V8.4L16 3.2Z"
        fill="currentColor"
        fillOpacity="0.12"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M16 9.5 17.1 12l2.7.4-2 1.95.5 2.7L16 15.7l-2.3 1.35.5-2.7-2-1.95L14.9 12 16 9.5Z"
        fill="currentColor"
      />
      <path
        d="M16 17.5v4.7M14.4 20.2h3.2M14.4 21.7h2.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Wordmark({ className }: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <Logo className="h-7 w-7" />
      <span className="text-lg font-semibold tracking-tight text-foreground">
        MapleKey
      </span>
    </div>
  );
}
